module.exports = __webpack_public_path__ + "img/article-image-2.0aa21858.webp";